import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { base_url } from "../../Global";

const AppManager = () => {
  const [iosVersion, setIosVersion] = useState("");
  const [androidVersion, setAndroidVersion] = useState("");
  const [isEditIosVersion, setIsEditIosVersion] = useState(false);
  const [isEditAndroidVersion, setIsEditAndroidVersion] = useState(false);

  const getAppInfo = async () => {
    try {
      const response = await fetch(base_url + "/app/getInfo?appID=legacyApp");
      const resp = await response.json();
      const data = resp?.appsetting;
      setIosVersion(data[0]?.iosVersion ?? "");
      setAndroidVersion(data[0]?.androidVersion ?? "");
    } catch (error) {
      console.error("Error fetching app info:", error);
    }
  };

  useEffect(() => { getAppInfo(); }, []);

  const handleComplete = async () => {
    let temp = { appID: "legacyApp" };
    if (isEditIosVersion) temp.iosVersion = iosVersion;
    if (isEditAndroidVersion) temp.androidVersion = androidVersion;
    if (temp?.androidVersion || temp?.iosVersion) {
      try {
        const response = await fetch(base_url + "/app/updateInfo", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(temp),
        });
        if (response.status === 200) alert("Data Updated");
        else alert("Something went wrong! Try Again");
      } catch (error) {
        alert("Network error. Try Again");
      }
    }
  };

  const inputStyle = (enabled) => ({
    width: "100%",
    padding: "12px 16px",
    borderRadius: "8px",
    border: "none",
    outline: "none",
    fontSize: "16px",
    boxSizing: "border-box",
    backgroundColor: enabled ? "white" : "#d1d5db",
    color: "#1f2937",
    cursor: enabled ? "text" : "not-allowed",
    fontFamily: "inherit",
  });

  const VersionCard = ({ label, value, isEdit, onEdit, onChange, placeholder }) => (
    <div style={{
      backgroundColor: "#1f2937",
      borderRadius: "12px",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
      }}>
        <h6 style={{
          margin: 0,
          fontSize: "16px",
          fontWeight: 600,
          color: "white",
          textTransform: "capitalize",
        }}>
          {label}
        </h6>
        <button
          onClick={onEdit}
          style={{
            padding: "6px 16px",
            backgroundColor: isEdit ? "#ef4444" : "white",
            color: isEdit ? "white" : "#1f2937",
            border: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          {isEdit ? "Cancel" : "Edit"}
        </button>
      </div>

      <input
        type="text"
        placeholder={placeholder}
        disabled={!isEdit}
        value={value}
        onChange={onChange}
        style={inputStyle(isEdit)}
      />

      {!isEdit && (
        <p style={{ margin: 0, fontSize: "12px", color: "#9ca3af" }}>
          Click Edit to modify this version
        </p>
      )}
    </div>
  );

  return (
    <div style={{
      flex: 1,
      minHeight: "100vh",
      backgroundColor: "#374151",
      color: "white",
      padding: "24px 16px",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}>
      <ToastContainer />

      <h1 style={{
        margin: "0 0 28px 0",
        fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
        fontWeight: 600,
        textTransform: "capitalize",
      }}>
        App Manager
      </h1>

      {/* ✅ Version cards — stacked on mobile, side by side on desktop */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: "20px",
        maxWidth: "900px",
      }}>
        <VersionCard
          label="iOS Version"
          value={iosVersion}
          isEdit={isEditIosVersion}
          onEdit={() => setIsEditIosVersion(!isEditIosVersion)}
          onChange={(e) => setIosVersion(e.target.value)}
          placeholder="iOS version"
        />
        <VersionCard
          label="Android Version"
          value={androidVersion}
          isEdit={isEditAndroidVersion}
          onEdit={() => setIsEditAndroidVersion(!isEditAndroidVersion)}
          onChange={(e) => setAndroidVersion(e.target.value)}
          placeholder="Android version"
        />
      </div>

      {/* ✅ Update button */}
      <div style={{ marginTop: "28px", maxWidth: "900px", display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={handleComplete}
          style={{
            padding: "12px 40px",
            backgroundColor: "white",
            color: "#1f2937",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
            width: "100%",
            maxWidth: "200px",
          }}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default AppManager;